export default {
  queryCityPointRule: '/courier-sqp-api/h5/v1/queryCityPointRule'
}
